module.exports = __webpack_public_path__ + "img/140.3.7794c400.png";